import { isMonetizationProUser } from '../isMonetizationProUser/isMonetizationProUser';
import { isSmartChargingProUser } from '../isSmartChargingProUser/isSmartChargingProUser';
import { isTerpelTenant } from '../isTerpelTenant/isTerpelTenant';
import { isVoucherProUser } from '../isVoucherProUser/isVoucherProUser';

export const isProUser = () => {
  if (isSmartChargingProUser()) {
    return true;
  }

  if (isMonetizationProUser()) {
    return true;
  }

  if (isVoucherProUser()) {
    return true;
  }

  if (isTerpelTenant()) {
    return true;
  }

  return false;
};
